import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Index from "../views/Index.vue";
import Issues from "../views/Issues.vue";
import Settings from "../views/Settings.vue";
import Coordinate from "../views/Coordinate.vue";
import SPDocSync from "../views/SPDocSync.vue";
import ProjectList from '../views/ProjectList.vue';
import ProjectAccessApproval from '../views/ProjectAccessApproval.vue'
import BluebeamConnect from '../views/BluebeamConnect.vue'
Vue.use(VueRouter);

// Determine the title based on the hostname
const isCadpro = window.location.hostname.includes("cadpro-bim-tools");
const INDEX_TITLE = isCadpro ? "CPS BIM Tools" : "Conectio";
const DEFAULT_TITLE = "Conectio";

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Index",
    component: Index,
    meta: {
      title: INDEX_TITLE,
    },
  },
  {
    path: "/issues",
    name: "Issues",
    component: Issues,
    meta: {
      title: "Issue Manager",
      reload: true,
    },
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    meta: {
      title: "License Setup",
    },
  },
  {
    path: "/coordinate",
    name: "Coordinate",
    component: Coordinate,
    meta: {
      title: "Model Coordination",
    },
  },
  {
    path: "/spdocsync",
    name: "Sharepoint Doc Sync",
    component: SPDocSync,
    meta: {
      title: "Sharepoint Doc Sync",
    },
  },
  {
    path: '/projectlist',
    name: 'ProjectList',
    component: ProjectList,
    meta: {
      title: "Project Access"
    }
  },
  {
    path: '/project-access-approval',
    name: 'ProjectAccessApproval',
    component: ProjectAccessApproval,
    meta: {
      title: "Project Access Approval"
    }
  },
  {
    path: '/bluebeam-access',
    name: 'BluebeamConnect',
    component: BluebeamConnect,
    meta: {
      title: "Bluebeam Access"
    }
  },
];

const router = new VueRouter({
  routes,
});

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta?.title || DEFAULT_TITLE;
  });
});

export default router;
